module.exports = "https://cdn.thelire.com/ins/resource/lh_special_three_like@3x.1682a56126145689b08346d2a855f3ad.png";